import type { ReactNode } from "react";

export interface FrameAlertsProps {
  children: ReactNode;
}

/**
 * Optional fixed-region for alerts/toasts that should live above content
 * regardless of scroll position. Frame doesn't impose a render location for
 * alerts — pages that don't use this slot are free to render `<Alert>`
 * inline (e.g. login screens render alerts in the form panel). Use this slot
 * when you want a fixed, top-of-viewport alert region (matching
 * authenticated-app behaviour).
 */
export function FrameAlerts({ children }: FrameAlertsProps) {
  return <>{children}</>;
}
